import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Slider from '@react-native-community/slider';
import Colors from '../colors';
const styles = {
  default: {
    cursor: 'pointer'
  },
  thumbStyle: {
    width: 20,
    height: 20,
    cursor: 'pointer'
  }
};
const StyledContainer = styled.View`
  position: relative;
  marginVertical: 6px;
`;
const StyledTrack = styled.View`
  height: 8px;
  width: '100%';
  background: ${Colors.lightGray300};
  border-radius: 4px;
`;
const StyledProgress = styled.View`
  height: 8px;
  width: ${props => props.width}%;
  background: ${Colors.mint400};
  border-radius: 4px;
  border-top-right-radius: ${props => props.borderRadius}px;
  border-bottom-right-radius: ${props => props.borderRadius}px;
`;
const SliderContainer = styled.View`
  position: absolute;
  top: -6px;
  width: 100%;
`;
export default function SliderBar(props) {
  const [state, setValue] = useState(props.value || props.minAmount);
  const range = props.maxAmount - props.minAmount;
  const adjustedValue = state - props.minAmount;
  const percentage = adjustedValue * 100 / range;
  const borderRadius = percentage < 100 ? 0 : 4;
  return /*#__PURE__*/React.createElement(StyledContainer, null, /*#__PURE__*/React.createElement(StyledTrack, null, /*#__PURE__*/React.createElement(StyledProgress, {
    width: percentage,
    borderRadius: borderRadius
  })), /*#__PURE__*/React.createElement(SliderContainer, null, /*#__PURE__*/React.createElement(Slider, {
    value: props.value,
    minimumValue: props.minAmount,
    maximumValue: props.maxAmount,
    upperLimit: props.upperLimit,
    step: props.step,
    onValueChange: value => {
      props.onChange(value);
      setValue(value);
    },
    style: styles.default,
    maximumTrackTintColor: Colors.transparent,
    minimumTrackTintColor: Colors.transparent,
    thumbStyle: styles.thumbStyle,
    thumbTintColor: Colors.mint400
  })));
}
SliderBar.defaultProps = {
  value: 0,
  minAmount: 0,
  maxAmount: 1000,
  upperLimit: 1000,
  step: 100,
  onChange: () => {}
};
SliderBar.propTypes = {
  value: PropTypes.number,
  minAmount: PropTypes.number,
  maxAmount: PropTypes.number,
  upperLimit: PropTypes.number,
  step: PropTypes.number,
  onChange: PropTypes.func
};
//# sourceMappingURL=slider.js.map